
import {initWebComponent} from "@/helpers/web-component-helper";
import {hideAllInfo, hideLayerInfoForm} from "@/helpers/layer/info/layer-info-helper";

const template = document.createElement('template');
template.innerHTML = `<header-button 
    data-icon="fa fa-info-circle" 
    data-tooltip="openInfo">
</header-button>`;

export class HeaderInfoComponent extends HTMLElement {
    constructor(){
        super();
        initWebComponent(this, template)

        this.addEventListener('click', () => {

            const element = document.querySelectorAll('bookmark-info')[0]
            const classList = [...element.classList]

            hideLayerInfoForm()

            if(classList.includes('d-none')) {
                element.classList.remove('d-none')
                element.parentNode.classList.remove('d-none')
            } else {
                hideAllInfo()
            }
        });
    }
}

